<template>
  <div
    :class="`${blockClass}__arrows splide__arrows`"
  >
    <button
      class="splide__arrow splide__arrow--prev"
      type="button"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.carousel.previous')"
      />

      <arrow-left />
    </button>

    <div
      class="
      js-splide-counter
      splide__arrows-counter
      splide-arrows__counter
      text-heading-2xs mx-l"
      v-text="`${curentIndex}/${pageCount}`"
    />

    <button
      class="splide__arrow splide__arrow--next"
      type="button"
    >
      <span
        class="visually-hidden"
        v-text="$string('accessibility.carousel.next')"
      />

      <arrow-right />
    </button>
  </div>
</template>

<script>

/**
 * Vue: Splide arrows (splide-arrows)
 * -----------------------------------------------------------------------------
 * Slide carousel arrows.
 *
 */

import ArrowRight from '~icons/directional-navigation/arrow/right.svg'
import ArrowLeft from '~icons/directional-navigation/arrow/left.svg'

export default {
  name: 'SplideArrows',
  components: {
    ArrowRight,
    ArrowLeft,
  },
  props: {
    blockClass: {
      type: String,
      default: '',
    },
    pageCount: {
      type: Number,
      default: 0,
    },
    curentIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      cnvsGlobal: true,
    }
  },

  mounted() {
    // Not empty
  },

  methods: {
    // Not empty
  },
}
</script>
